import { styled } from '@mui/material/styles';
import { TURN_STYLES } from '@/styles/theme';

export const FailureCard = styled('div')(({ theme }) => ({
  width: '100%',

  paddingTop: '14px',
  paddingRight: '16px',
  paddingBottom: '14px',
  paddingLeft: '16px',

  backgroundColor: theme.palette.mode === 'dark' ? '#3f1d24' : '#fff1f2',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: theme.palette.mode === 'dark' ? TURN_STYLES.darkErrorLight : '#fca5a5',
  borderLeftWidth: '4px',
  borderLeftColor: theme.palette.mode === 'dark' ? TURN_STYLES.darkErrorLight : '#ef4444',
  borderRadius: '8px',
}));

export const SuccessCard = styled('div')(({ theme }) => ({
  width: '100%',

  paddingTop: '14px',
  paddingRight: '16px',
  paddingBottom: '14px',
  paddingLeft: '16px',

  backgroundColor: theme.palette.mode === 'dark' ? '#052e16' : '#f0fdf4',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: theme.palette.mode === 'dark' ? TURN_STYLES.darkSuccessLight : '#86efac',
  borderRadius: '8px',
}));

export const PanelTitle = styled('p')(({ theme }) => ({
  margin: 0,

  color: theme.palette.mode === 'dark' ? TURN_STYLES.darkNeutralLight : TURN_STYLES.neutralDark,
  fontSize: '15px',
  fontWeight: 700,
  lineHeight: '22px',
}));

export const FailureList = styled('ul')({
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',

  marginTop: '10px',
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  padding: 0,

  listStyle: 'none',
});

export const FailureItem = styled('li')(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '8px',

  color: theme.palette.mode === 'dark' ? TURN_STYLES.darkErrorLight : TURN_STYLES.errorDark,
  fontSize: '14px',
  lineHeight: '20px',
}));

export const FailureIcon = styled('span')({
  display: 'flex',

  marginTop: '1px',

  color: '#ef4444',
  fontSize: '18px',
});

export const SuccessList = styled('ul')({
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',

  marginTop: '10px',
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  padding: 0,

  listStyle: 'none',
});

export const SuccessItem = styled('li')(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '8px',

  color: theme.palette.mode === 'dark' ? TURN_STYLES.darkSuccessLight : '#166534',
  fontSize: '14px',
  lineHeight: '20px',
}));

export const SuccessIcon = styled('span')({
  display: 'flex',

  marginTop: '1px',

  color: TURN_STYLES.successDark,
  fontSize: '18px',
});

export const PanelFooter = styled('p')(({ theme }) => ({
  marginTop: '12px',
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,

  color: theme.palette.mode === 'dark' ? TURN_STYLES.darkSecondaryColor : TURN_STYLES.primaryColor,
  fontSize: '13px',
  lineHeight: '18px',
}));
